import { render, staticRenderFns } from "./SchoolRegistrationList.vue?vue&type=template&id=44cc53a6"
import script from "./SchoolRegistrationList.vue?vue&type=script&lang=js"
export * from "./SchoolRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./SchoolRegistrationList.vue?vue&type=style&index=0&id=44cc53a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports